import * as firebase from 'firebase';
import { browserHistory } from 'react-router'
import {
    CurrentQuizDispatch,
    AllQuestionDisptach,
    NumberOFQuestions,
    FavoriteQuizDispatch,
    FavoriteQuizState,
    FavoriteErrorDispatch,
    FavoriteErrorState
} from '../reducers/container/deatilDispatch';
import { FavorQuizesData } from '../reducers/container/deatilDispatch';

export function DetailsQuiz(key) {
    return dispatch => {
        // console.log('key', key)
        let nodeId = key.toLowerCase();
        dispatch(CurrentQuizDispatch({}))
        dispatch(AllQuestionDisptach({}))
        firebase.database().ref('test/' + nodeId + '/').once('value', (editeQuiz) => {
            let quiz = editeQuiz.val();
            // dispatch(MakingQuizDispatch(quiz))
            // console.log(quiz,'quiz')
            if (quiz.type.toLowerCase() === 'quiz') {
                firebase.database().ref('questions/' + nodeId + '/').once('value', (editeQuestions) => {
                    let questions = editeQuestions.val();
                    let SuposeArray = [];
                    for (var prop in questions) {
                        questions[prop].prokey = prop;
                        SuposeArray.push(questions[prop])
                    }
                    // console.log(SuposeArray.length,'SuposeArray')
                    dispatch(NumberOFQuestions(SuposeArray.length))
                    dispatch(AllQuestionDisptach(SuposeArray))
                })
                // console.log(quiz,'SuposeArray quiz')

                dispatch(CurrentQuizDispatch(quiz))
                browserHistory.push('/detail-quiz')
            }
            else if (quiz.type.toLowerCase() === 'jumble') {
                firebase.database().ref('questions/' + nodeId + '/').once('value', (editeQuestions) => {
                    let questions = editeQuestions.val();
                    let SuposeArray = [];
                    for (var prop in questions) {
                        questions[prop].prokey = prop;
                        SuposeArray.push(questions[prop])
                    }
                    // console.log(SuposeArray.length,'SuposeArray')

                    dispatch(NumberOFQuestions(SuposeArray.length))
                    dispatch(AllQuestionDisptach(SuposeArray))
                    // console.log(questions,'SuposeArray quiz')
                })

                browserHistory.push('/detail-jumble')
                dispatch(CurrentQuizDispatch(quiz))
            }
        })

    }
}


export function FetchDetailsQuiz(key) {
    return dispatch => {
        // console.log('key', key)
        let nodeId = key.toLowerCase();
        dispatch(CurrentQuizDispatch({}))
        dispatch(AllQuestionDisptach({}))
        firebase.database().ref('test/' + nodeId + '/').once('value', (editeQuiz) => {
            let quiz = editeQuiz.val();
            // dispatch(MakingQuizDispatch(quiz))
            // console.log(quiz,'quiz')
            if (quiz.type === 'Quiz') {
                firebase.database().ref('questions/' + nodeId + '/').once('value', (editeQuestions) => {
                    let questions = editeQuestions.val();
                    let SuposeArray = [];
                    for (var prop in questions) {
                        questions[prop].prokey = prop;
                        SuposeArray.push(questions[prop])
                    }
                    // console.log(SuposeArray.length,'SuposeArray')
                    dispatch(NumberOFQuestions(SuposeArray.length))
                    dispatch(AllQuestionDisptach(SuposeArray))
                })
                // console.log(quiz,'SuposeArray quiz')

                dispatch(CurrentQuizDispatch(quiz))
                // browserHistory.push('/detail-quiz')
            }
            else if (quiz.type === 'Jumble') {
                firebase.database().ref('questions/' + nodeId + '/').once('value', (editeQuestions) => {
                    let questions = editeQuestions.val();
                    let SuposeArray = [];
                    for (var prop in questions) {
                        questions[prop].prokey = prop;
                        SuposeArray.push(questions[prop])
                    }
                    // console.log(SuposeArray.length,'SuposeArray')

                    dispatch(NumberOFQuestions(SuposeArray.length))
                    dispatch(AllQuestionDisptach(SuposeArray))
                    // console.log(questions,'SuposeArray quiz')
                })

                // browserHistory.push('/detail-jumble')
                dispatch(CurrentQuizDispatch(quiz))
            }
        })

    }
}


export function FavoriteQuizAction(action, Allquiz) {
    return dispatch => {
        // console.log(action, 'fav');
        dispatch(FavorQuizesData({}))
        firebase.database().ref('favorite/' + action.nodeKey + '/').child(action.userUid).once('value', (data) => {
            let favorite = data.val();
            // console.log('share', share)
            if (favorite === null) {
                firebase.database().ref('favorite/' + action.nodeKey + '/' + action.userUid + '/').set(action.userUid)
                    .then(() => {
                        firebase.database().ref('favorite/').once('value', (data) => {
                            let favData = data.val()
                            let FavorQuizes = {}
                            for (var key in Allquiz) {
                                // console.log("check key", key in sharedWithMe)
                                if (key in favData) {
                                    Allquiz[key].favQuiz = favData[key];
                                    for (var favKey in favData[key]) {
                                        if (action.userUid === favData[key][favKey]) {
                                            //  console.log('matched',allUsers[i])
                                            FavorQuizes[key] = Allquiz[key];
                                            FavorQuizes[key].favQuiz[favKey] = action.userUid;
                                        }
                                    }
                                }
                                
                            }
                            // console.log('FavorQuizes', FavorQuizes)
                            dispatch(FavorQuizesData(FavorQuizes))
                            let favoriteMessage = 'Your selected MAGE Set is now added to favourites!';
                            dispatch(FavoriteQuizDispatch(favoriteMessage));
                            dispatch(FavoriteQuizState())
                            setTimeout(() => {
                                dispatch(FavoriteQuizState())
                            }, 4000)
                        })
                    })
                    .catch((error) => {
                        let errorMessage = error.message;
                        dispatch(FavoriteErrorDispatch(errorMessage));
                        dispatch(FavoriteErrorState())
                        setTimeout(() => {
                            dispatch(FavoriteErrorState())
                        }, 4000)
                    })
            }
            else {
                let error = 'This set is already a favourite!';
                dispatch(FavoriteErrorDispatch(error));
                dispatch(FavoriteErrorState())
                setTimeout(() => {
                    dispatch(FavoriteErrorState())
                }, 4000)
            }
        })
    }
}

export function UnFavoriteQuizAction(action, Allquiz) {
    return dispatch => {
        dispatch(FavorQuizesData({}))
        firebase.database().ref('favorite/' + action.nodeKey + '/' + action.userUid + '/').remove()
            .then(() => {
                firebase.database().ref('favorite/').once('value', (data) => {
                    let favData = data.val()
                    let FavorQuizes = {}
                    for (var key in Allquiz) {
                        // console.log("check key", key in sharedWithMe)
                        if (key in favData) {
                            Allquiz[key].favQuiz = favData[key];
                            for (var favKey in favData[key]) {
                                if (action.userUid === favData[key][favKey]) {
                                    //  console.log('matched',allUsers[i])
                                    FavorQuizes[key] = Allquiz[key];
                                    FavorQuizes[key].favQuiz[favKey] = action.userUid;
                                }
                            }
                        }
                    }
                    // console.log('FavorQuizes', FavorQuizes)
                    dispatch(FavorQuizesData(FavorQuizes))
                    let favoriteMessage = 'Your selected quiz has been removed from favorite list!';
                    dispatch(FavoriteQuizDispatch(favoriteMessage));
                    dispatch(FavoriteQuizState())
                    setTimeout(() => {
                        dispatch(FavoriteQuizState())
                    }, 4000)
                })
            })
            .catch((error) => {
                let errorMessage = error.message;
                dispatch(FavoriteErrorDispatch(errorMessage));
                dispatch(FavoriteErrorState())
                setTimeout(() => {
                    dispatch(FavoriteErrorState())
                }, 4000)
            })
    }
}


// WEBPACK FOOTER //
// ./src/action/detailAction.jsx